<section id="secao-institucional">
  <div class="container">
    <!-- <div class="row row-titulo">
      <h1 class="titulo">Os pilares da fundação são:</h1>
    </div> -->
    <div class="row">
      <!-- <div class="col-md-6">
        <div class="pilares">
          <li class="media">
            <img
              src="assets/imagens/educacao-tecnologica-circle.png"
              class="img-circle"
              alt="..."
            />
            <div class="media-body">
              <h5 class="h">Educação Tecnológica</h5>
              <p class="texto">Projeto Educere</p>
            </div>
          </li>
          <li class="media">
            <img
              src="assets/imagens/empreendedorismo-inovacao-circle.png"
              class="img-circle"
              alt="..."
            />
            <div class="media-body">
              <h5 class="h">Empreendedorismo e Inovação</h5>
              <p class="texto">Incubação de empresas</p>
            </div>
          </li>
          <li class="media">
            <img
              src="assets/imagens/cultura-colaborativa-circle.png"
              class="img-circle"
              alt="..."
            />
            <div class="media-body">
              <h5 class="h">Cultura Colaborativa</h5>
              <p class="texto">Network Educere</p>
            </div>
          </li>
          <li class="media">
            <img
              src="assets/imagens/apoio-cultural-circle.png"
              class="img-circle"
              alt="..."
            />
            <div class="media-body">
              <h5 class="h">Apoio Cultural</h5>
              <p class="texto">
                Ballet Educere, Ateliê de Escultura Clássica e Clube da Cultura
              </p>
            </div>
          </li>
        </div>
      </div> -->
      <div class="col-md-6">
        <p class="texto-institucional-pilares">
          A Fundação Educere de Campo Mourão foi criada em outubro de 1997 com o
          objetivo de fomentar a pesquisa científica e tecnológica integrando
          pesquisadores com o setor produtivo visando ao desenvolvimento e o
          aprimoramento de tecnologias.
        </p>
      </div>
    </div>
    <div class="row pt-5 pb-5">
      <span class="texto-institucional">
        Inserida em um cenário essencialmente agrícola, a Fundação Educere
        iniciou as suas atividades no ano de 2000 com uma infraestrutura de
        1.400 m² de área construída, tendo como principal mantenedora a empresa
        Cristófoli Biossegurança. Com o objetivo de estimular o interesse de
        adolescentes para a área de tecnologia, a Fundação Educere passou a
        ofertar gratuitamente, cursos de eletrônica, mecânica e design. <br />
        Percebendo o potencial empreendedor de seus alunos, a instituição passou
        a incentivá-los no desenvolvimento de produtos, resultando nas primeiras
        empresas incubadas e graduadas pela Fundação Educere.
      </span>
    </div>
  </div>
</section>
